// extracted by mini-css-extract-plugin
export default {"name":"HubManagement_name__fGhfo","identifier":"HubManagement_identifier__UJiTt","actionDisplay":"HubManagement_actionDisplay__cJVa9"};